import { useTranslations } from '@vocab/react';
import { FieldLabel, Loader, Stack } from 'braid-design-system';

import { useGetSharedProfileVisibility } from 'src/modules/graphql/visibility/data';

import translations from './.vocab';
import { ManageUrl } from './ManageUrl/ManageUrl';

export const SharedProfileLink = () => {
  const { t } = useTranslations(translations);
  const { shareableProfileUrl, shareableProfileDisplayUrl, loading, error } =
    useGetSharedProfileVisibility();

  const hasSharedProfile = shareableProfileUrl && shareableProfileDisplayUrl;

  return loading || error ? (
    <Loader size="small" />
  ) : (
    <>
      {hasSharedProfile ? (
        <Stack space="xsmall">
          <FieldLabel
            label={t('Your Shared Profile link')}
            htmlFor="manage-url-txt"
          />
          <ManageUrl
            profileUrl={shareableProfileUrl}
            profileDisplayUrl={shareableProfileDisplayUrl}
            isActive={false}
          />
        </Stack>
      ) : null}
    </>
  );
};
